// extracted by mini-css-extract-plugin
export default {"devide":"checkout_devide__HZ2Gd","useflx":"checkout_useflx__tLPmi","box":"checkout_box__kSB8u","agree1":"checkout_agree1__15CJa"};